export default __webpack_public_path__ + "static/media/region-icon.efb0deba.svg";